import { render, staticRenderFns } from "./OurTechnology.vue?vue&type=template&id=4d3515a5&"
import script from "./OurTechnology.vue?vue&type=script&lang=js&"
export * from "./OurTechnology.vue?vue&type=script&lang=js&"
import style0 from "./OurTechnology.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports